import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { UI_GoToTopNavigation } from 'ui/components/3-organisms/GoToTopNavigation/GoToTopNavigation';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { UI_DetailCard } from 'ui/components/2-molecules/Card/DetailCard/DetailCard';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { MainRegion } from '1-project/MainRegion/MainRegion';

interface Props extends Content.Page {
	properties: Content.OrganisationPageProperties;
}

export const OrganisationPage = (props: Props) => {
	const { properties } = props;
	const { pageSections, organisation } = properties ?? {};
	const dictionary = useDictionaryContext();
	const toTopTitle = dictionary.getAction('ToTop');

	const details = [
		{
			heading: dictionary.getContact?.('Email'),
			text: organisation?.email,
		},
		{
			heading: dictionary.getContact?.('Phone'),
			text: organisation?.phone,
		},
		{
			heading: dictionary.getContact?.('Address'),
			text: organisation?.address,
		},
		{
			heading: dictionary.getContact?.('OpeningHours'),
			text: organisation?.openingHours,
		},
	];

	return (
		<MainRegion
			header={
				<UI_HeaderCard
					heading={organisation?.name}
					teaser={organisation?.description}
					image={organisation?.logo ? { url: organisation.logo.url } : undefined}
					imageAltText=""
					smallImage={true}
				/>
			}
		>
			<UI_DetailCard items={details} />
			<UI_Container width="Small">
				{pageSections.map((sectionModule, index) => (
					<DynamicModule key={index} module={sectionModule} />
				))}
			</UI_Container>
			<UI_GoToTopNavigation title={toTopTitle} />
		</MainRegion>
	);
};
